export type ReservationMode = "phone" | "widget";

// Laisser sur "phone" pendant le développement, puis passer à "widget"
// lorsque la réservation en ligne doit être activée.
export const RESERVATION_MODE = "phone" as ReservationMode;

export const RESERVATION_WIDGET_PREVIEW_KEY = "digital-reservation-widget-preview";
const RESERVATION_WIDGET_PREVIEW_PARAMETER = "reservation-preview";

/**
 * La réservation en ligne est-elle active pour cette visite ?
 *
 * Deux façons : le mode global, ou `?reservation-preview=widget` qui l'ouvre pour la session en
 * cours. Le paramètre est retiré de l'URL après lecture, pour qu'un lien partagé n'emporte pas
 * l'aperçu avec lui.
 *
 * ## L'adresse du loader ne vit plus ici
 *
 * Elle est dans le `<head>` de `public/index.html`, avec l'identifiant du restaurant. Ce fichier
 * en gardait une copie : deux endroits pour une même valeur, et rien n'aurait signalé leur
 * divergence — un identifiant modifié ici seulement aurait donné un widget qui charge pour un
 * autre restaurant. La condition d'aperçu, elle, est bien lue aux deux endroits, mais elle est
 * *dérivée* de l'URL et du stockage de session : les deux lecteurs lisent la même source.
 */
export const isReservationWidgetEnabled = () => {
    if (RESERVATION_MODE === "widget") {
        return true;
    }

    try {
        const url = new URL(window.location.href);
        const previewMode = url.searchParams.get(RESERVATION_WIDGET_PREVIEW_PARAMETER);

        if (previewMode === "widget" || previewMode === "phone") {
            if (previewMode === "widget") {
                window.sessionStorage.setItem(RESERVATION_WIDGET_PREVIEW_KEY, "enabled");
            } else {
                window.sessionStorage.removeItem(RESERVATION_WIDGET_PREVIEW_KEY);
            }

            url.searchParams.delete(RESERVATION_WIDGET_PREVIEW_PARAMETER);
            window.history.replaceState(null, "", `${url.pathname}${url.search}${url.hash}`);
        }

        return window.sessionStorage.getItem(RESERVATION_WIDGET_PREVIEW_KEY) === "enabled";
    } catch {
        return false;
    }
};
